import { render, staticRenderFns } from "./BrandpageMagazine.vue?vue&type=template&id=f4099bb8&scoped=true"
import script from "./BrandpageMagazine.vue?vue&type=script&lang=js"
export * from "./BrandpageMagazine.vue?vue&type=script&lang=js"
import style0 from "./BrandpageMagazine.vue?vue&type=style&index=0&id=f4099bb8&prod&lang=scss"
import style1 from "./BrandpageMagazine.vue?vue&type=style&index=1&id=f4099bb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4099bb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
